import { Controller } from '@hotwired/stimulus'

// (11) 98765-4321 — o +55 é fixo fora do campo.
export default class extends Controller {
  connect() {
    this.mask()
    this.element.addEventListener('input', () => this.mask())
  }

  mask() {
    let d = this.element.value.replace(/\D/g, '')
    if (d.length > 11 && d.startsWith('55')) d = d.slice(2)
    d = d.slice(0, 11)
    let v = d.length ? '(' + d.slice(0, 2) : ''
    if (d.length > 2) v += ') ' + d.slice(2, d.length === 11 ? 7 : 6)
    if (d.length > (d.length === 11 ? 7 : 6)) v += '-' + d.slice(d.length === 11 ? 7 : 6)
    this.element.value = v
  }
}
